module.exports = __webpack_public_path__ + "img/emoticon-nps-2-on.f1542cf8.svg";